import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../../cfet-core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-customer-instant-verification',
    templateUrl: './customer-instant-verification.component.html',
    styleUrls: ['./customer-instant-verification.component.scss'],
    standalone: false
})
export class CustomerInstantVerificationComponent extends CfetBaseComponent implements OnInit {

  @Output() setNewSession = new EventEmitter<any>();
  @Output() showCancelModal = new EventEmitter<any>();

  constructor(private router: Router) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  continueToProfile(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PROFILE]);
      this.setNewSession.emit(true);
    }
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

}
